var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"auto"}},[_c('v-card',[_c('v-card-text',[_c('p',[_vm._v("Bonjour "+_vm._s(_vm.name)+" "+_vm._s(_vm.surname)+"!")])])],1)],1)],1),_vm._v(" "),_c('HomeFavoris')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }